module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-15.3f6b6207.png";